import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { Router } from '@angular/router';
import { PipelineBoardViews, PipelinePageCacheService } from '../pipeline/cache/pipeline-page-cache.service';

export enum PipelinePageUrls {
  BOARD = '/pipeline/board',
  TABLE = '/pipeline/table',
}

@Injectable({ providedIn: 'root' })
export class PipelineSwitcherService {
  private readonly cachedPipelinePage$$ = new ReplaySubject<PipelinePageUrls>(1);
  readonly cachedPipelinePage$ = this.cachedPipelinePage$$.asObservable();

  constructor(private readonly router: Router, private readonly cache: PipelinePageCacheService) {
    if (this.cache.lastViewedPipelinePageView === PipelineBoardViews.DEFAULT_BOARD) {
      this.cachedPipelinePage$$.next(PipelinePageUrls.BOARD);
    } else {
      this.cachedPipelinePage$$.next(PipelinePageUrls.TABLE);
    }
  }

  navigateToTable(): void {
    this.router.navigate([PipelinePageUrls.TABLE], { queryParamsHandling: 'preserve' });
    this.cachedPipelinePage$$.next(PipelinePageUrls.TABLE);
    this.cache.setLastViewedPipelinePageView(PipelineBoardViews.DEFAULT_TABLE);
  }

  navigateToBoard(): void {
    this.router.navigate([PipelinePageUrls.BOARD], { queryParamsHandling: 'preserve' });
    this.cachedPipelinePage$$.next(PipelinePageUrls.BOARD);
    this.cache.setLastViewedPipelinePageView(PipelineBoardViews.DEFAULT_BOARD);
  }
}
